import {
  Box,
  Card,
  Typography,
  Container,
  Divider
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { styled } from '@mui/material/styles';
import Footer from 'src/components/Footer';

const MainContent = styled(Box)(
  ({ theme }) => `
    height: 100%;
    display: flex;
    flex: 1;
    overflow: auto;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: ${theme.spacing(4)} 0;
`
);

function Privacy() {
  return (
    <>
      <Helmet>
        <title>Privacy Policy - Portfoliomatic</title>
      </Helmet>
      <MainContent>
        <Container maxWidth="md">
          <Card sx={{ p: 4 }}>
            <Typography variant="h3" component="h1" gutterBottom>
              Privacy Policy
            </Typography>
            <Divider sx={{ mb: 3 }} />

            <Typography variant="body1" paragraph>
              This Privacy Policy describes how Portfoliomatic collects, uses, and protects your personal information when you use our platform.
            </Typography>

            <Typography variant="h5" component="h2" gutterBottom>
              Information We Collect
            </Typography>
            <Typography variant="body1" paragraph>
              We collect information you provide directly to us, such as when you create an account, configure investment strategies, or contact us for support. This may include your name, email address, and portfolio configurations.
            </Typography>

            <Typography variant="h5" component="h2" gutterBottom>
              How We Use Your Information
            </Typography>
            <Typography variant="body1" paragraph>
              We use the information we collect to provide, maintain, and improve our services, including generating strategy recommendations and sending educational email notifications.
            </Typography>

            <Typography variant="h5" component="h2" gutterBottom>
              Information Sharing
            </Typography>
            <Typography variant="body1" paragraph>
              We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as described in this policy or as required by law.
            </Typography>

            <Typography variant="h5" component="h2" gutterBottom>
              Data Security
            </Typography>
            <Typography variant="body1" paragraph>
              We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
            </Typography>

            <Typography variant="h5" component="h2" gutterBottom>
              Cookies and Analytics
            </Typography>
            <Typography variant="body1" paragraph>
              We may use cookies and similar technologies to enhance your experience and collect analytics data to improve our platform. You can control cookie preferences through your browser settings.
            </Typography>

            <Typography variant="h5" component="h2" gutterBottom>
              Your Rights
            </Typography>
            <Typography variant="body1" paragraph>
              You have the right to access, update, or delete your personal information. You may also opt out of email communications at any time.
            </Typography>

            <Typography variant="h5" component="h2" gutterBottom>
              Contact Us
            </Typography>
            <Typography variant="body1" paragraph>
              If you have questions about this Privacy Policy, please contact us at contact@portfoliomatic.ca.
            </Typography>

            <Typography variant="body2" sx={{ mt: 4, fontStyle: 'italic' }}>
              Last updated: {new Date().toLocaleDateString()}
            </Typography>
          </Card>
        </Container>
      </MainContent>
      <Footer />
    </>
  );
}

export default Privacy;